import { type ApiError } from '@/shared/api/client';

/**
 * Extrai a mensagem de erro do campo indicado.
 *
 * O servidor devolve o campo que recusou em `details.field`. Mostrar a mensagem no
 * campo certo evita o padrao em que a pessoa le "dados invalidos" e precisa
 * adivinhar qual dos doze campos esta errado.
 */
export function fieldErrorOf(
  error: ApiError | null,
  field: string,
): string | undefined {
  if (!error) return undefined;
  if (error.details?.field !== field) return undefined;
  return error.message;
}
